import { Theme } from '@emotion/react';
import React from 'react';

import { DisplayProps } from './display';
import { SizeProps } from './size';
import { SpacingProps } from './spacing';
import { boxStyle } from './boxCssDefs';

export type TextAlign = 'left' | 'right' | 'center';

export type BoxProps = React.HTMLAttributes<HTMLDivElement> &
  SpacingProps &
  DisplayProps &
  SizeProps & {
    textAlign?: TextAlign;
  };

/**
 * @deprecated Deprecated — use pantry Box instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-box--docs
 * Migration: Replace Box with the pantry Box component.
 */
export const Box: React.FunctionComponent<React.PropsWithChildren<BoxProps>> = ({
  children,
  mt,
  mb,
  my,
  ml,
  mr,
  mx,
  margin,
  pt,
  pb,
  py,
  pl,
  pr,
  px,
  padding,
  display = 'block',
  justifyContent,
  alignContent,
  alignItems,
  alignSelf,
  height,
  minHeight,
  maxHeight,
  width,
  minWidth,
  maxWidth,
  textAlign = 'left',
  ...rest
}) => {
  return (
    <div
      css={(theme: Theme) =>
        boxStyle(
          theme,
          {
            mt,
            mb,
            my,
            ml,
            mr,
            mx,
            margin,
            pt,
            pb,
            py,
            pl,
            pr,
            px,
            padding,
          } as {
            [key: string]: number | undefined;
          },
          { display, justifyContent, alignContent, alignItems, alignSelf },
          { height, minHeight, maxHeight, width, minWidth, maxWidth },
          textAlign
        )
      }
      {...rest}
    >
      {children}
    </div>
  );
};
